import { MoveGenerator } from '../../jscaip/AI/AI';
import { TrexoRules } from './TrexoRules';
export class TrexoMoveGenerator extends MoveGenerator {
    rules = TrexoRules.get();
    getListMoves(node, _config) {
        return this.rules.getLegalMoves(node.gameState);
    }
}
